import {
  JOURNEY_EMBED_MODE,
  LANGUAGE
} from '@epilot/journey-logic-commons/src/types/next'
import { z } from 'zod'

const stringBoolSchemaFactory = (defaultValue?: boolean) => {
  const base = z
    .string()
    .toLowerCase()
    .optional()
    .transform((val) =>
      typeof val === 'undefined' ? undefined : val === 'true'
    )

  if (typeof defaultValue === 'undefined') {
    return base.pipe(z.boolean())
  }

  return base.pipe(z.boolean().default(defaultValue))
}

export const ParamsSchema = z
  .object({
    journeyId: z.string().optional(),
    debug: stringBoolSchemaFactory(false),
    preview: stringBoolSchemaFactory(false),
    topBar: stringBoolSchemaFactory(false),
    mode: z
      .nativeEnum(JOURNEY_EMBED_MODE)
      .optional()
      .default(JOURNEY_EMBED_MODE.FULL_SCREEN),
    isEmbedded: stringBoolSchemaFactory(false),
    lang: z.nativeEnum(LANGUAGE).optional().default(LANGUAGE.DE),
    journeyToken: z.string().optional()
  })
  .catchall(z.string()) // everything else is a string
  .transform((params) => {
    // normalize journeyToken
    // TODO: remove support for `journey_token` in the future
    if (params.journey_token && !params.journeyToken) {
      params.journeyToken = params.journey_token
      delete params.journey_token
    }

    return params
  })
